/**
 * @generated SignedSource<<559f2cd89144972abe026656d40377d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemDuplicateAutoRecordRule$data = {
  readonly id: string;
  readonly ruleType: AutoRecordRuleType;
  readonly " $fragmentType": "AutoRecordRulesListItemDuplicateAutoRecordRule";
};
export type AutoRecordRulesListItemDuplicateAutoRecordRule$key = {
  readonly " $data"?: AutoRecordRulesListItemDuplicateAutoRecordRule$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemDuplicateAutoRecordRule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemDuplicateAutoRecordRule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleType",
      "storageKey": null
    }
  ],
  "type": "AutoRecordRule",
  "abstractKey": null
};

(node as any).hash = "e951703201518ec2c4d0d1c9de402b42";

export default node;
